import TiptapHorizontalRule from '@tiptap/extension-horizontal-rule';

import {nodeInputRule} from '@tiptap/core';

import appStyles from '../app-post-style.module.css';

export const TimeWebkitHorizontalRuleExtension = TiptapHorizontalRule
    .extend({
        addInputRules() {
            return [
                nodeInputRule({
                    find: /^(?:-{3,}|_{3,}|\*{3,})(?:\s)$/,
                    type: this.type,
                }),
            ];
        },
    }).configure({
        HTMLAttributes: {
            class: appStyles.horizontalRule,
        },
    });
